import { Component, OnInit } from '@angular/core';
import { BatchTableComponent } from '../batch-table/batch-table.component';
import { BatchTableFilterComponent } from '../batch-table-filter/batch-table-filter.component';

@Component({
    selector: 'app-batch-page',
    templateUrl: './batch-page.component.html',
    styleUrls: ['./batch-page.component.scss'],
    imports: [BatchTableFilterComponent, BatchTableComponent]
})
export class BatchPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
